import { render, staticRenderFns } from "./MaskComponent.vue?vue&type=template&id=03b29211&scoped=true&"
import script from "./MaskComponent.vue?vue&type=script&lang=ts&"
export * from "./MaskComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MaskComponent.vue?vue&type=style&index=0&id=03b29211&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b29211",
  null
  
)

export default component.exports